module.exports = __webpack_public_path__ + "assets/Nu.8df9fdd77c72ef81cd8ce0bf29351247.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Nu.png
// module id = 791
// module chunks = 0